<template>
  <v-layout v-resize="onResize" row>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="headline">Pagamento Recorrente</span>
        </v-card-title>
        <v-card-title v-if="newPaymentError">
          <v-alert
            :value="true"
            color="error"
            icon="warning"
            outline
          >
            <p>Erro ao gerar pagamento!</p>
            <p>Código: {{response.errors[0].response_code}}</p>
            <p>Detalhe: {{response.errors[0].response_code_detail}}</p>
          </v-alert>
        </v-card-title>
        <v-card-title v-if="newPaymentStatus">
          <v-alert
            :value="true"
            color="success"
            icon="check_circle"
            outline
          >
            Pagamento recorrente criado com sucesso, com ID: {{response[0].id}}
          </v-alert>
        </v-card-title>
        <v-progress-linear :indeterminate="isLoading"></v-progress-linear>

        <v-form  ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-xl fluid>
            <v-layout wrap>
              <v-flex xs12 sm2>
                <v-text-field  label="Valor" v-model.lazy="amount" v-money="money" :rules="amountRules" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm1>
                <v-text-field
                  value=""
                  label="À cada"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm1>
                <v-text-field id="rangeSize" type='number' v-model.lazy="rangeSize" :rules="amountRules" label="Intervalo" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm1>
                <v-select
                  v-model.lazy="paymentOptionCode"
                  :items="rangeTypes"
                  item-text="name"
                  item-value="value"
                  label="Tipo de intervalo"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model.lazy="cardHolderName" :rules="nameRules" label="Name impresso no cartão" required>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field id="cardNumber" type='number' v-model.lazy="pan" label="Número do cartão" maxLength="16" :counter="16" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="expiryMonth"
                  :hint="`${months[0].name}`"
                  :items="months"
                  item-text="name"
                  item-value="value"
                  label="Mês de vencimento"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex><br>
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="expiryYear"
                  :hint="`${years[0].name}`"
                  :items="years"
                  item-text="name"
                  item-value="value"
                  label="Ano de vencimento"
                  persistent-hint
                  return-object
                  single-line
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="scheme"
                  :hint="`${schemes[0].name}`"
                  :items="schemes"
                  item-text="name"
                  item-value="value"
                  label="Bandeira"
                  persistent-hint
                  return-object
                  single-line
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field id="securityCode" type='number' v-model.lazy="securityCode" :rules="codeRules" label="Código de segurança | CVC" maxLength="3" :counter="3" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p>Vencimento</p>
                <v-date-picker v-if="!isMobile" v-model="dueOn" locale="pt-br" :landscape="true" :reactive="true" required></v-date-picker>
                <v-date-picker v-else v-model="dueOn" locale="pt-br" :landscape="false" :reactive="true" required></v-date-picker>
              </v-flex>
              <v-flex xs12 md6>
                <p>Válido até</p>
                <v-date-picker v-if="!isMobile" v-model="finalDate" locale="pt-br" :landscape="true" :reactive="true" required></v-date-picker>
                <v-date-picker v-else v-model="finalDate" locale="pt-br" :landscape="false" :reactive="true" required></v-date-picker>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-bind:color="color" flat @click="validate">Enviar</v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { changed } from '@/helpers/layout';
  import {VMoney} from 'v-money';
  import {mask} from 'vue-the-mask'
  import moment from 'moment'
  import format from 'date-fns/format'

  export default {
    name: 'SubscriptionNew',
    data: () => ({
      paylink: [],
      alert: false,
      valid: true,
      isMobile: false,
      paymentOptionCode: '',
      cardHolderName: '',
      pan: '',
      amount: '',
      expiryMonth: '',
      expiryYear: '',
      securityCode: '',
      scheme: '',
      subscription: true,
      subsMonths: [],
      picker: new Date().toISOString().substr(0, 10),
      rangeType: "monthly",
      rangeSize: '1',
      finalDate: '',
      dueOn: '',
      nameRules: [
        v => !!v || 'Nome é requirido',
      ],
      codeRules: [
        v => !!v || 'CVC é requirido',
        v => (v && v.length <= 3) || 'CVC precisar ser menor que 3 cacacteres.'
      ],
      amountRules: [
        v => !!v || 'Valor deve ser válido',
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      days: Array.from({length: 31}, (v, k) => k+1),
      rangeTypes: [
        { name: 'Dia', value: 'daily'},
        { name: 'Mês', value: 'monthly'},
        { name: 'Ano', value: 'yearly'},
      ],
      months: [
        { name: 'Jan', value: '01'},
        { name: 'Fev', value: '02'},
        { name: 'Mar', value: '03'},
        { name: 'Abr', value: '04'},
        { name: 'Mai', value: '05'},
        { name: 'Jun', value: '06'},
        { name: 'Jul', value: '07'},
        { name: 'Ago', value: '08'},
        { name: 'Set', value: '09'},
        { name: 'Out', value: '10'},
        { name: 'Nov', value: '11'},
        { name: 'Dez', value: '12'},
      ],
      years: [
        { name: `${(new Date().getFullYear()).toString()}`, value: `${(new Date().getFullYear()).toString()}`},
        { name: `${(new Date().getFullYear()+1).toString()}`, value: `${(new Date().getFullYear()+1).toString()}`},
        { name: `${(new Date().getFullYear()+2).toString()}`, value: `${(new Date().getFullYear()+2).toString()}`},
        { name: `${(new Date().getFullYear()+3).toString()}`, value: `${(new Date().getFullYear()+3).toString()}`},
        { name: `${(new Date().getFullYear()+4).toString()}`, value: `${(new Date().getFullYear()+4).toString()}`},
        { name: `${(new Date().getFullYear()+5).toString()}`, value: `${(new Date().getFullYear()+5).toString()}`},
        { name: `${(new Date().getFullYear()+6).toString()}`, value: `${(new Date().getFullYear()+6).toString()}`},
        { name: `${(new Date().getFullYear()+7).toString()}`, value: `${(new Date().getFullYear()+7).toString()}`},
        { name: `${(new Date().getFullYear()+8).toString()}`, value: `${(new Date().getFullYear()+8).toString()}`},
        { name: `${(new Date().getFullYear()+9).toString()}`, value: `${(new Date().getFullYear()+9).toString()}`},
        { name: `${(new Date().getFullYear()+10).toString()}`, value: `${(new Date().getFullYear()+10).toString()}`},
        { name: `${(new Date().getFullYear()+11).toString()}`, value: `${(new Date().getFullYear()+11).toString()}`},
        { name: `${(new Date().getFullYear()+12).toString()}`, value: `${(new Date().getFullYear()+12).toString()}`},
        { name: `${(new Date().getFullYear()+13).toString()}`, value: `${(new Date().getFullYear()+13).toString()}`},
        { name: `${(new Date().getFullYear()+14).toString()}`, value: `${(new Date().getFullYear()+14).toString()}`},
        { name: `${(new Date().getFullYear()+15).toString()}`, value: `${(new Date().getFullYear()+15).toString()}`},
      ],
      schemes: [
        { name: 'MASTERCARD', value: 'MASTERCARD'},
        { name: 'VISA', value: 'VISA'},
        { name: 'VISA_ELECTRON', value: 'VISA_ELECTRON'},
        { name: 'MAESTRO', value: 'MAESTRO'},
        { name: 'AMEX', value: 'AMEX'},
      ],
    }),
    directives: {money: VMoney, mask},
    mounted() {
      this.$store.commit('payments/LOADING_DATA', false);
    },
    computed: {
      ...mapGetters({
        response: 'payments/newPayment',
        isLoading: 'payments/loadingData',
        newPaymentError: 'payments/newPaymentError',
        newPaymentStatus: 'payments/newPaymentStatus',
        color: 'account/color',
      }),
    },
    methods: {

       onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
      validate () {
        if (this.$refs.form.validate()) {
          this.payment = {
            subscription: true,
            verify_3ds: false,
            cardHolderName: this.cardHolderName,
            amount: this.amount.replace(/[^\d]+/g,''),
            paymentOptionCode: "1",
            pan: this.pan.replace(/[^\d]+/g,''),
            expiryMonth: this.expiryMonth.value,
            expiryYear: this.expiryYear.value,
            securityCode: this.securityCode,
            scheme: this.scheme.value,
            range_type: this.rangeType,
            range_size: this.rangeSize,
            final_date: this.finalDate,
            due_date: this.dueOn
          }
          this.$store.dispatch('payments/newPayment', this.payment)
          this.alert = this.isLoading
          this.$refs.form.reset()
        }
      },
      updatePage () {
        window.location.reload()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      }
    },
  }
</script>

<style>

@font-face {
  font-family: 'fontello';
  src: url('../../../../assets/fonts/fontello.eot');
  src: url('../../../../assets/fonts/fontello.eot?13442593#iefix') format('embedded-opentype'),
        url('../../../../assets/fonts/fontello.woff2?13442593') format('woff2'),
        url('../../../../assets/fonts/fontello.woff?13442593') format('woff'),
        url('../../../../assets/fonts/fontello.ttf?13442593') format('truetype'),
        url('../../../../assets/fonts/fontello.svg?13442593#fontello') format('svg');
  font-weight: normal;
  font-style: normal;
}

#cardNumber,#securityCode {
  font-family: "fontello";
  text-transform: none;

  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */

  /* add spacing to better separate each image */
  letter-spacing: 2px;
  font-size: 10px
}

</style>
